/**
 * Affiliate intake — handle-only, auto URL + scrape stats, button toggles.
 */
(function () {
  var SUBPATH = "bbe-checkout-app";
  var SUBMIT_ENDPOINT = "/apps/" + SUBPATH + "/api/affiliate-intake";
  var ENRICH_ENDPOINT = "/apps/" + SUBPATH + "/api/affiliate-intake/enrich";
  var SOCIAL = ["tiktok", "instagram", "youtube", "facebook", "snapchat"];

  function stripAt(value) {
    return String(value || "")
      .trim()
      .replace(/^@+/, "");
  }

  function formatCount(n) {
    if (n == null || n === "") return "—";
    var num = Number(n);
    if (!isFinite(num)) return "—";
    if (num >= 1000000) return (num / 1000000).toFixed(num >= 10000000 ? 0 : 1).replace(/\.0$/, "") + "M";
    if (num >= 1000) return (num / 1000).toFixed(num >= 10000 ? 0 : 1).replace(/\.0$/, "") + "K";
    return String(Math.round(num));
  }

  function buildUrl(platform, handle) {
    var clean = stripAt(handle);
    if (!clean) return "";
    switch (platform) {
      case "instagram":
        return "https://www.instagram.com/" + clean.toLowerCase() + "/";
      case "tiktok":
        return "https://www.tiktok.com/@" + clean.toLowerCase();
      case "youtube":
        if (clean.indexOf("UC") === 0 && clean.length >= 20) {
          return "https://www.youtube.com/channel/" + clean;
        }
        return "https://www.youtube.com/@" + clean;
      case "facebook":
        return "https://www.facebook.com/" + clean.replace(/^\/+/, "");
      case "snapchat":
        return "https://www.snapchat.com/add/" + clean.toLowerCase();
      default:
        return "";
    }
  }

  function checkedValues(form, name) {
    return Array.prototype.map.call(
      form.querySelectorAll('input[name="' + name + '"]:checked'),
      function (el) {
        return el.value;
      },
    );
  }

  function initRoot(root) {
    if (root.getAttribute("data-bbe-affiliate-intake-ready") === "1") return;
    root.setAttribute("data-bbe-affiliate-intake-ready", "1");

    var form = root.querySelector("[data-form]");
    var success = root.querySelector("[data-success]");
    var errorEl = root.querySelector("[data-error]");
    var submitBtn = root.querySelector("[data-submit]");
    if (!form) return;

    var enrichTokens = {};

    function showError(message) {
      if (!errorEl) return;
      errorEl.hidden = !message;
      errorEl.textContent = message || "";
    }

    function syncToggleButtons() {
      root.querySelectorAll("[data-toggle]").forEach(function (btn) {
        var name = btn.getAttribute("data-toggle");
        var value = btn.getAttribute("data-value");
        var input = form.querySelector(
          'input[name="' + name + '"][value="' + value + '"]',
        );
        var on = !!(input && input.checked);
        btn.setAttribute("aria-pressed", on ? "true" : "false");
        btn.classList.toggle("is-outlined", !on);
      });
    }

    function clearFieldInvalid(el) {
      if (!el) return;
      var field = el.closest(".bbe-ai__field");
      if (field) field.classList.remove("is-invalid");
    }

    function setFieldInvalid(el) {
      if (!el) return;
      var field = el.closest(".bbe-ai__field");
      if (field) field.classList.add("is-invalid");
    }

    function setGroupInvalid(name, invalid) {
      var step = root.querySelector(
        name === "createWhere" ? '[data-step="create-where"]' : '[data-step="hoping-for"]',
      );
      var groupError = root.querySelector('[data-group-error="' + name + '"]');
      if (step) step.classList.toggle("is-invalid", !!invalid);
      if (groupError) groupError.hidden = !invalid;
    }

    function syncPlatformRows() {
      var selected = checkedValues(form, "createWhere");
      SOCIAL.forEach(function (platform) {
        var row = root.querySelector('[data-platform-row="' + platform + '"]');
        if (!row) return;
        var visible = selected.indexOf(platform) !== -1;
        row.hidden = !visible;
        var handleInput = row.querySelector("[data-handle]");
        if (handleInput) {
          if (visible) {
            handleInput.setAttribute("required", "required");
            handleInput.setAttribute("aria-required", "true");
          } else {
            handleInput.removeAttribute("required");
            handleInput.setAttribute("aria-required", "false");
            clearFieldInvalid(handleInput);
          }
        }
      });
      if (selected.length > 0) setGroupInvalid("createWhere", false);
    }

    root.querySelectorAll("[data-toggle]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var name = btn.getAttribute("data-toggle");
        var value = btn.getAttribute("data-value");
        var input = form.querySelector(
          'input[name="' + name + '"][value="' + value + '"]',
        );
        if (!input) return;
        input.checked = !input.checked;
        syncToggleButtons();
        if (name === "createWhere") syncPlatformRows();
        if (name === "hopingFor" && checkedValues(form, "hopingFor").length > 0) {
          setGroupInvalid("hopingFor", false);
        }
      });
    });

    form.querySelectorAll('input[name="name"], input[name="email"]').forEach(function (input) {
      input.addEventListener("input", function () {
        if (input.value.trim()) clearFieldInvalid(input);
      });
    });

    syncToggleButtons();
    syncPlatformRows();

    function setStats(row, data) {
      var followers = data.followers;
      var likes = data.likes;
      var posts = data.posts;
      var followersInput = row.querySelector("[data-followers]");
      var likesInput = row.querySelector("[data-likes]");
      var postsInput = row.querySelector("[data-posts]");
      var urlInput = row.querySelector("[data-url]");
      var stats = row.querySelector("[data-stats]");

      if (urlInput && data.url) urlInput.value = data.url;
      if (followersInput) {
        followersInput.value = followers != null ? String(followers) : "";
        if (data.source) followersInput.setAttribute("data-source", data.source);
      }
      if (likesInput) likesInput.value = likes != null ? String(likes) : "";
      if (postsInput) postsInput.value = posts != null ? String(posts) : "";

      var fDisp = row.querySelector("[data-followers-display]");
      var lDisp = row.querySelector("[data-likes-display]");
      var pDisp = row.querySelector("[data-posts-display]");
      if (fDisp) fDisp.textContent = formatCount(followers);
      if (lDisp) lDisp.textContent = formatCount(likes);
      if (pDisp) pDisp.textContent = formatCount(posts);

      if (stats) {
        stats.hidden = !(followers != null || likes != null || posts != null);
      }
    }

    function collectPlatforms() {
      var selected = checkedValues(form, "createWhere");
      var platforms = [];
      SOCIAL.forEach(function (platform) {
        if (selected.indexOf(platform) === -1) return;
        var row = root.querySelector('[data-platform-row="' + platform + '"]');
        if (!row) return;
        var handle = stripAt((row.querySelector("[data-handle]") || {}).value || "");
        var urlInput = row.querySelector("[data-url]");
        var followersInput = row.querySelector("[data-followers]");
        var likesInput = row.querySelector("[data-likes]");
        var postsInput = row.querySelector("[data-posts]");
        var url = (urlInput && urlInput.value) || buildUrl(platform, handle);
        platforms.push({
          platform: platform,
          handle: handle || null,
          url: url || null,
          followers: followersInput && followersInput.value !== "" ? Number(followersInput.value) : null,
          likes: likesInput && likesInput.value !== "" ? Number(likesInput.value) : null,
          posts: postsInput && postsInput.value !== "" ? Number(postsInput.value) : null,
          followersSource: followersInput ? followersInput.getAttribute("data-source") : null,
          enrichmentStatus: row.getAttribute("data-enrichment-status") || null,
        });
      });
      return platforms;
    }

    function scheduleEnrich(platform, row) {
      var handleInput = row.querySelector("[data-handle]");
      var statusEl = row.querySelector("[data-enrich-status]");
      var handle = stripAt(handleInput ? handleInput.value : "");
      if (!handle) {
        setStats(row, { followers: null, likes: null, posts: null, url: "" });
        if (statusEl) statusEl.textContent = "";
        return;
      }

      var url = buildUrl(platform, handle);
      var urlInput = row.querySelector("[data-url]");
      if (urlInput) urlInput.value = url;

      var token = String(Date.now()) + "-" + Math.random();
      enrichTokens[platform] = token;
      if (statusEl) statusEl.textContent = "Looking up profile…";
      row.setAttribute("data-enrichment-status", "pending");

      window.setTimeout(function () {
        if (enrichTokens[platform] !== token) return;
        fetch(ENRICH_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          credentials: "same-origin",
          body: JSON.stringify({ platform: platform, handle: handle, url: url }),
        })
          .then(function (res) {
            return res.json().then(function (body) {
              return { ok: res.ok, body: body };
            });
          })
          .then(function (result) {
            if (enrichTokens[platform] !== token) return;
            var body = result.body || {};
            row.setAttribute("data-enrichment-status", body.status || "error");
            setStats(row, {
              url: body.url || url,
              followers: body.followers,
              likes: body.likes,
              posts: body.posts,
              source: body.source || "scrape",
            });
            if (body.status === "ok") {
              if (statusEl) statusEl.textContent = "Found your stats";
              return;
            }
            if (statusEl) {
              statusEl.textContent =
                body.status === "rate_limited"
                  ? "Lookup limit reached — you can still submit."
                  : "Couldn’t auto-read stats — you can still submit.";
            }
          })
          .catch(function () {
            if (enrichTokens[platform] !== token) return;
            row.setAttribute("data-enrichment-status", "error");
            if (statusEl) statusEl.textContent = "Couldn’t auto-read stats — you can still submit.";
          });
      }, 350);
    }

    SOCIAL.forEach(function (platform) {
      var row = root.querySelector('[data-platform-row="' + platform + '"]');
      if (!row) return;
      var handleInput = row.querySelector("[data-handle]");
      if (!handleInput) return;
      handleInput.addEventListener("input", function () {
        if (stripAt(handleInput.value)) clearFieldInvalid(handleInput);
      });
      handleInput.addEventListener("blur", function () {
        scheduleEnrich(platform, row);
      });
      handleInput.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          event.preventDefault();
          handleInput.blur();
        }
      });
    });

    form.addEventListener("submit", function (event) {
      event.preventDefault();
      showError("");
      setGroupInvalid("createWhere", false);
      setGroupInvalid("hopingFor", false);
      form.querySelectorAll(".bbe-ai__field.is-invalid").forEach(function (field) {
        field.classList.remove("is-invalid");
      });

      var nameInput = form.querySelector('[name="name"]');
      var emailInput = form.querySelector('[name="email"]');
      var name = (nameInput && nameInput.value) || "";
      var email = (emailInput && emailInput.value) || "";
      var createWhere = checkedValues(form, "createWhere");
      var hopingFor = checkedValues(form, "hopingFor");
      var notes = (form.querySelector('[name="notes"]') || {}).value || "";
      var honeypot = (form.querySelector('[name="website"]') || {}).value || "";
      var platforms = collectPlatforms();
      var firstInvalid = null;

      if (!name.trim()) {
        setFieldInvalid(nameInput);
        firstInvalid = firstInvalid || nameInput;
      }
      if (!email.trim()) {
        setFieldInvalid(emailInput);
        firstInvalid = firstInvalid || emailInput;
      }
      if (!name.trim() || !email.trim()) {
        showError("Name and email are required.");
        if (firstInvalid && firstInvalid.focus) firstInvalid.focus();
        return;
      }
      if (createWhere.length < 1) {
        setGroupInvalid("createWhere", true);
        showError("Pick at least one place you create.");
        var createBtn = root.querySelector('[data-toggle="createWhere"]');
        if (createBtn && createBtn.focus) createBtn.focus();
        return;
      }
      if (hopingFor.length < 1) {
        setGroupInvalid("hopingFor", true);
        showError("Pick at least one thing you’re hoping for.");
        var hopeBtn = root.querySelector('[data-toggle="hopingFor"]');
        if (hopeBtn && hopeBtn.focus) hopeBtn.focus();
        return;
      }
      for (var i = 0; i < platforms.length; i++) {
        if (!platforms[i].handle) {
          var missingRow = root.querySelector(
            '[data-platform-row="' + platforms[i].platform + '"]',
          );
          var missingHandle = missingRow && missingRow.querySelector("[data-handle]");
          setFieldInvalid(missingHandle);
          showError("Add a username for each selected social platform.");
          if (missingHandle && missingHandle.focus) missingHandle.focus();
          return;
        }
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute("aria-busy", "true");
      }

      fetch(SUBMIT_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({
          name: name.trim(),
          email: email.trim(),
          createWhere: createWhere,
          hopingFor: hopingFor,
          platforms: platforms,
          notes: notes.trim() || null,
          honeypot: honeypot,
        }),
      })
        .then(function (res) {
          return res.json().then(function (body) {
            return { ok: res.ok, status: res.status, body: body };
          });
        })
        .then(function (result) {
          if (!result.ok || !result.body || !result.body.ok) {
            showError(
              (result.body && result.body.message) ||
                (result.status === 401
                  ? "Form is temporarily unavailable. Try again later."
                  : "Something went wrong. Please try again."),
            );
            return;
          }
          form.hidden = true;
          if (success) success.hidden = false;
        })
        .catch(function () {
          showError("Something went wrong. Please try again.");
        })
        .finally(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.removeAttribute("aria-busy");
          }
        });
    });
  }

  function boot() {
    document.querySelectorAll("[data-bbe-affiliate-intake]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
